/**
 * EhrClosingSection - the closing ask on /ehr: the offer in one line and the
 * waitlist form again, so a reader convinced by the questions signs up where
 * they are. ClosingCtaSection's geometry (centred column, soft top wash,
 * padding), with its rose wash turned to the hero's violet at the same
 * lightness and alpha.
 */

import type { ReactNode } from "react";
import { EhrHeading } from "./EhrHeading";

export function EhrClosingSection({ children }: { children: ReactNode }) {
  return (
    <section
      data-screen-label="Join the waitlist"
      className="home-anim ehr-closing-section"
      style={{
        position: "relative",
        padding: "140px 24px 150px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden",
        color: "hsl(225 45% 14%)",
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom, hsl(265 70% 94% / 0.35), transparent 45%)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: 1000,
        }}
      >
        <EhrHeading lead="A modern EHR, free," beat="with AI billing built in." ownLine marginBottom={0} />
        {children}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .ehr-closing-section {
            padding-top: 88px !important;
            padding-bottom: 96px !important;
          }
        }
      `}</style>
    </section>
  );
}
